import { VerticalContainer } from '@/components';
import React from 'react';
import { R } from '@/Resources.resx';
import { AttachmentIcon } from '@/components/Icons';
import { cn } from '@/lib/cn';

type UploadFilesButtonProps = {
    className?: string;
    accept?: string;
    onFileChange: any;
};

export const UploadFilesButton = ({
    className,
    accept,
    onFileChange,
}: UploadFilesButtonProps) => {
    const inputRef = React.useRef<HTMLInputElement>(null);

    return (
        <VerticalContainer className={cn('w-full', className)}>
            <input
                ref={inputRef}
                type="file"
                multiple={true}
                onChange={onFileChange}
                hidden={true}
                accept={accept}
            />
            <button
                className="btn btn-ghost btn-sm inline-flex w-fit gap-4 self-end"
                onClick={(e) => {
                    inputRef.current?.click();
                    e.preventDefault();
                }}
            >
                <AttachmentIcon />
                {R.AddFile}
            </button>
        </VerticalContainer>
    );
};
